export default __webpack_public_path__ + "static/media/fox_icon.8c99d2e4.png";